/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Product_Type_GoiInputs */

const vi_shop_product_type_goi = /** @type {(inputs: Shop_Product_Type_GoiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói`)
};

/**

* @param {Shop_Product_Type_GoiInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_product_type_goi = /** @type {((inputs?: Shop_Product_Type_GoiInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Product_Type_GoiInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_product_type_goi(inputs)
});